import { ResultType } from "./Types/ResultType";

export class LocalData {
    activeStep: number;
    isStarted: boolean;
    surveyName?: String;
    results: Array<ResultType>;
}